import { AxiosInstance } from 'axios'

import { ChangePasswordRequest } from '@modules/auth/types/Password/requests'

export class PasswordService {
  private instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async changePassword(data: ChangePasswordRequest): Promise<void> {
    await this.instance.post(`/change-password`, data)
  }
}

export const passwordService = (instance: AxiosInstance) => new PasswordService(instance)
